import { render, staticRenderFns } from "./BrandForm.vue?vue&type=template&id=15447ed6&scoped=true&"
import script from "./BrandForm.vue?vue&type=script&lang=js&"
export * from "./BrandForm.vue?vue&type=script&lang=js&"
import style0 from "./BrandForm.vue?vue&type=style&index=0&id=15447ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15447ed6",
  null
  
)

export default component.exports